import { render, staticRenderFns } from "./deathData.vue?vue&type=template&id=ee43a55e&"
import script from "./deathData.vue?vue&type=script&lang=js&"
export * from "./deathData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports